import { Flex, Heading, Button, Input, Box, FormControl, FormLabel, Select, RadioGroup, Radio, FormHelperText, FormErrorMessage, Spinner, Stack, Checkbox } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb'
import CustomInput from '../../../../components/common/Input/input'
import { useIMask } from 'react-imask';
import * as api from '../../../../api/usuario';
import Swal from 'sweetalert2'
import { listarCategoriasAtivas } from '../../../../api/categoria'
import { Camera } from "lucide-react";
import './editar-usuario.scss'
import { listarSecretariasAtivas } from '../../../../api/secretarias'

interface Usuario {
  dscCpf: number;
  dscNome: string;
  dscDdd: string;
  dscCelular: number;
  dscEmail: number;
  dscSenha: number;
  codPerfilAcesso: number;
  sitRegistro: number;
}

function AdicionarUsuario() {
  const [codPerfilAcesso, setTipoPerfil] = useState<any[]>([]);
  const [campoObrigatorio, setCampoObrigatorio] = useState<boolean>(false);
  const [isEmailValido, setEmailValido] = useState<boolean>(false);
  const [usuarios, setUsuarios] = useState<Usuario | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [categoriaSelecionada, setCategoriaSelecionada] = useState<number[]>([]);
  const [categoriaRemovida, setCategoriaRemovida] = useState<number[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImagem] = useState<any>();
  const [imagemUsuario, setimagemUsuario] = useState<File | null>(null);
  const [profileImagePreview, setProfileImagePreview] = useState<string>("");
  const [nomeCdn, setNomeCdn] = useState<any>(null);
  const [temFotoPerfil, setTemFotoPerfil] = useState<boolean>(false);
  const valorInicialCheckboxSecretaria = useRef<Set<number>>(new Set());
  const navigate = useNavigate()
  const { id } = useParams();

  useEffect(() => {
    const fetchTipoPerfis = async () => {
      setLoading(true);
      try {
        const data = await api.listarTiposPerfisAtivos();
        setTipoPerfil(data);
      } catch (error) {
        console.error('Erro ao buscar tipos de perfis ativos:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTipoPerfis();
    fetchCategorias();
    fetchSecretariasAtivas();
  }, []);

  const fetchCategorias = async () => {
    try {
      const data = await listarCategoriasAtivas();
      setCategorias(data);
    } catch (error) {
      console.error('Erro ao buscar categorias ativas:', error);
    }
  };

  const fetchSecretariasAtivas = async () => {
    try {
      const data = await listarSecretariasAtivas();
      setSecretarias(data);
    } catch (error) {
      console.error('Erro ao buscar secretarias ativas:', error);
    }
  };

  const fetchObterUsuario = async () => {
    if (!id) return;
    try {
      const data = await api.obterUsuario(Number(id));
      setUsuarios(data);
  
      const secretariasSelecionadas: number[] = (data.usuarioSecretariaDTO ?? [])
        .map((item: any) => Number(item.codSecretaria));  
      setFormValues({
        dscCpf: { value: data.dscCpf, error: false },
        dscNome: { value: data.dscNome, error: false },
        dscDdd: { value: data.dscDdd, error: false },
        dscCelular: { value: data.dscCelular, error: false },
        dscEmail: { value: data.dscEmail, error: false },
        dscSenha: { value: "", error: false },
        codPerfilAcesso: { value: data.codPerfilAcesso, error: false },
        sitRegistro: { value: data.sitRegistro, error: false },
        categoriaId: { value: data.usuarioCategoriaDTO.map((i: any) => i.seqCategoria.toString()), error: false },
        secretariaId: { value: secretariasSelecionadas, error: false },
      });
  
      valorInicialCheckboxSecretaria.current = new Set<number>(secretariasSelecionadas);  
      if (data.imagemUsuario && data.imagemUsuario.imagem?.trim()) {
        setTemFotoPerfil(true);
        setImagem(data.imagemUsuario.imagem);
        setProfileImagePreview(data.imagemUsuario.imagem);
  
        setFormValues((prev) => ({
          ...prev,
          imagem: { value: data.imagemUsuario.imagem, error: false },
        }));
  
        const delimiter = "%2F";
        const index = data.imagemUsuario.imagem.lastIndexOf(delimiter);
        const finalFileName =
          index !== -1
            ? data.imagemUsuario.imagem.substring(index + delimiter.length)
            : data.imagemUsuario.imagem;
        setNomeCdn(finalFileName);
      } else {
        setTemFotoPerfil(false);
      }
  
      const isEmailValido = emailRegex.test(data.dscEmail);
      setEmailValido(isEmailValido);
    } catch (error) {
      console.error("Erro ao obter usuario:", error);
    }
  };

  useEffect(() => {
    fetchObterUsuario();
  }, [id]);

  const [formValues, setFormValues] = useState<{
    dscCpf: { value: string; error: boolean };
    dscDdd: { value: string; error: boolean };
    dscNome: { value: string; error: boolean };
    dscCelular: { value: string; error: boolean };
    dscEmail: { value: string; error: boolean };
    dscSenha: { value: string; error: boolean };
    codPerfilAcesso: { value: string; error: boolean };
    sitRegistro: { value: any; error: boolean };
    categoriaId: { value: any[]; error: boolean };
    secretariaId: { value: any[]; error: boolean };
  }>({
    dscCpf: { value: '', error: false },
    dscDdd: { value: '', error: false },
    dscNome: { value: '', error: false },
    dscCelular: { value: '', error: false },
    dscEmail: { value: '', error: false },
    dscSenha: { value: '', error: false },
    codPerfilAcesso: { value: '', error: false },
    sitRegistro: { value: '', error: false },
    categoriaId: { value: [], error: false },
    secretariaId: { value: [], error: false },
  });

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setimagemUsuario(file);
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === "string") {
          setProfileImagePreview(reader.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const atualizarPreview = (url: string) => {
    if (url.startsWith("data:")) {
      return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${new Date().getTime()}`;
  };


  const handleCheckboxChange = (seqCategoria: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setCategoriaSelecionada((prev) => {
      const updatedPages = isChecked ? [...prev, seqCategoria] : prev.filter((id) => id !== seqCategoria);
      return updatedPages;
    });

    if (isChecked) {
      setCategoriaRemovida(prev => prev.filter(id => id !== seqCategoria));
    } else {
      setCategoriaRemovida(prev => [...prev, seqCategoria]);
    }

    setFormValues((prevValues: any) => {
      const updatedcategoriaIdValue = isChecked
        ? [...prevValues.categoriaId.value, seqCategoria.toString()]
        : prevValues.categoriaId.value.filter((id: string) => id !== seqCategoria.toString());

      return {
        ...prevValues,
        categoriaId: { value: updatedcategoriaIdValue },
      };
    });
  };

  const handleCheckboxSecretaria = (codSecretaria: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
  
    setFormValues((prevValues: any) => {
      const current: number[] = Array.isArray(prevValues.secretariaId?.value)
        ? prevValues.secretariaId.value
        : [];
  
      const updated = isChecked
        ? [...current, codSecretaria].filter((v, i, arr) => arr.indexOf(v) === i)
        : current.filter((id) => id !== codSecretaria);
  
      return {
        ...prevValues,
        secretariaId: { value: updated },
        ordemBanner: { value: 0 },
      };
    });
  };  

  const handleDeleteCategoria = async () => {
    try {
      for (const seqCategoria of categoriaRemovida) {
        await api.deletarRelacionamentoCategoria(seqCategoria, Number(id),);
      }

      setCategoriaRemovida([]);
    } catch (error) {
      console.error('Erro ao remover relacionamento de categorias:', error);
    }
  };

  const { ref: cpfRef } = useIMask(
    { mask: '000.000.000-00' },
    {
      onAccept: (value) => handleFieldChange('dscCpf', value)
    }
  );

  function mascaraCpf(cpf: string) {
    /* eslint-disable-next-line */
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  }

  function mascaraCelular(celular: string) {
    const { dscDdd, dscCelular } = formValues;
    if (dscCelular.value && dscDdd.value) {
      return celular.replace(/(\d{5})(\d{4})/g, "$1-$2");
    }
    return celular;
  }

  /* eslint-disable-next-line */
  const senhaRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[#\$%!@]).{8,255}$/;

  const validarSenha = (senha: string) => {
    return senhaRegex.test(senha);
  };

  /* eslint-disable-next-line */
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;

  const isFormValid = () => {
    const { dscCpf, dscNome, dscDdd, dscCelular, dscEmail, dscSenha, codPerfilAcesso, categoriaId } = formValues;

    const isCelularObrigatorio = campoObrigatorio === true
      ? (dscDdd.value && dscDdd.value.length >= 2 && dscCelular.value && dscCelular.value.length >= 9)
      : true;

    const isEmailValido = emailRegex.test(dscEmail.value);

    /* eslint-disable-next-line */
    const senhaRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[#\$%!@]).{8,255}$/;

    const isSenhaValida = dscSenha.value === '' || senhaRegex.test(dscSenha.value);

    return (
      dscCpf.value && dscNome.value && dscEmail.value && isSenhaValida &&
      dscCpf.value.length >= 11 &&
      (dscNome.value.length >= 3 && dscNome.value.length <= 160) &&
      dscEmail.value.length <= 80 &&
      isEmailValido &&
      (codPerfilAcesso.value != null) &&
      (categoriaId.value.length > 0) &&
      isCelularObrigatorio
    );
  };


  const handleFieldChange = (field: any, value: any) => {
    setFormValues({
      ...formValues,
      [field]: {
        error: false,
        value
      }
    });

    if (field === 'dscEmail') {
      const isEmailValido = emailRegex.test(value);
      setEmailValido(isEmailValido);
    }

    if (field === 'dscSenha') {
      const isSenhaValida = validarSenha(value);
      setFormValues(prevState => ({
        ...prevState,
        dscSenha: {
          value,
          error: !isSenhaValida
        }
      }));
    }
  };

  const handleSubmit = async () => {
    const {
      dscCpf,
      dscNome,
      dscDdd,
      dscCelular,
      dscEmail,
      dscSenha,
      codPerfilAcesso,
      sitRegistro,
      categoriaId,
      secretariaId
    } = formValues;
  
    const senhaParaEnviar = dscSenha.value || usuarios?.dscSenha;
  
    const secretariaAtualSelecionada = new Set<number>(secretariaId?.value ?? []);
    const secretariaInicialSelecionada = valorInicialCheckboxSecretaria.current;
    const toMark = Array.from(secretariaAtualSelecionada).filter((id) => !secretariaInicialSelecionada.has(id));
    const toUnmark = Array.from(secretariaInicialSelecionada).filter((id) => !secretariaAtualSelecionada.has(id));
    const usuarioSecretariaDTO = [
      ...toMark.map((id) => ({ codSecretaria: id, numRegistro: 1 })),
      ...toUnmark.map((id) => ({ codSecretaria: id, numRegistro: 0 })),
    ];
  
    const hasNewImage = Boolean(imagemUsuario?.name);
    const isOwnProfile = (() => {
      const dados = localStorage.getItem("dadosUsuario");
      if (!dados) return false;
      try {
        const u = JSON.parse(dados);
        return u?.seqUsuario === Number(id);
      } catch {
        return false;
      }
    })();
  
    const params: any = {
      dscCpf: dscCpf?.value ? dscCpf.value.replace(/\.|-/g, "") : null,
      dscNome: dscNome.value || null,
      dscDdd: dscDdd?.value || null,
      dscCelular: dscCelular?.value ? dscCelular.value.replace(/\.|-/g, "") : null,
      dscEmail: dscEmail.value || null,
      dscSenha: senhaParaEnviar,
      codPerfilAcesso: Number(codPerfilAcesso.value),
      sitRegistro: Number(sitRegistro.value),
      usuarioCategoriaDTO: (categoriaId?.value ?? []).map((id: any) => ({ seqCategoria: Number(id) })),
      usuarioSecretariaDTO
    };
  
    let cdnUrl: string | null = null;
  
    if (hasNewImage && !temFotoPerfil) {
      const formDataProfile = new FormData();
      formDataProfile.append("file", imagemUsuario as File);
  
      const fileExtension = (imagemUsuario as File).name.split(".").pop();
      let fileNameToSend = nomeCdn || "imagemUsuario";
      if (fileExtension && !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)) {
        fileNameToSend = `${fileNameToSend}.${fileExtension}`;
      }
  
      formDataProfile.append("fileName", fileNameToSend);
      formDataProfile.append("folderName", "imgUsuario");
  
      const cdnProfileData = await api.inserirFotoPerfilNoCdn(formDataProfile);
      if (typeof cdnProfileData === "string") {
        const match = cdnProfileData.match(/(https?:\/\/[^\s]+)/g);
        cdnUrl = match?.[0] ?? null;
      } else if (cdnProfileData?.url) {
        cdnUrl = cdnProfileData.url;
      }
      if (!cdnUrl) throw new Error("URL não encontrada na resposta do CDN.");
  
      params.imagemUsuario = { imagem: cdnUrl };
    }
  
    if (hasNewImage && temFotoPerfil) {
      const formData = new FormData();
      formData.append("file", imagemUsuario as File);
      formData.append("fileName", nomeCdn || "imagemUsuario");
      formData.append("folderName", "imgUsuario");
  
      const cdnData = await api.editarFotoPerfilNoCdn(formData);
      if (typeof cdnData === "string") {
        const match = cdnData.match(/(https?:\/\/[^\s]+)/g);
        cdnUrl = match?.[0] ?? null;
      } else if (cdnData?.url) {
        cdnUrl = cdnData.url;
      }
      if (!cdnUrl) throw new Error("URL não encontrada na resposta do CDN.");
  
      params.imagemUsuario = { imagem: cdnUrl };
    }
  
    setIsLoading(true);
    try {
      await handleDeleteCategoria();
      await api.editarUsuario(Number(id), params);
      if (isOwnProfile && hasNewImage && cdnUrl) {
        const dadosLocalStorage = localStorage.getItem("dadosUsuario");
        if (dadosLocalStorage) {
          const usuarioLocal = JSON.parse(dadosLocalStorage);
          if (usuarioLocal.seqUsuario === Number(id)) {
            const updatedUsuario = {
              ...usuarioLocal,
              imagemPerfil: atualizarPreview(cdnUrl),
            };
            localStorage.setItem("dadosUsuario", JSON.stringify(updatedUsuario));
            window.dispatchEvent(new Event("fotoPerfilUpdated"));
          }
        }
      }
  
      await Swal.fire({
        icon: "success",
        title: "Sucesso!",
        text: "Usuário editado com sucesso.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      });
  
      navigate("/cms/configuracao/gerenciar-usuario");
    } catch (error) {
      console.error("Erro ao editar usuário:", error);
      await Swal.fire({
        icon: "error",
        title: "Ocorreu um erro!",
        text: "Erro ao editar usuário. Tente novamente mais tarde.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      });
      navigate("/cms/configuracao/gerenciar-usuario");
    } finally {
      setIsLoading(false);
    }
  };

  const validarObrigatoriedadeTelefone = async () => {
    const { dscDdd, dscCelular } = formValues;

    if ((dscDdd.value && dscDdd.value.length >= 1) || (dscCelular.value && dscCelular.value.length >= 1)) {
      setCampoObrigatorio(true);
    } else {
      setCampoObrigatorio(false);
    }
  }

  useEffect(() => {
    validarObrigatoriedadeTelefone();
  });

  useEffect(() => {
    const isEmailValido = emailRegex.test(formValues.dscEmail.value);
    setEmailValido(isEmailValido);
  }, [formValues.dscEmail.value]);

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        mb="20px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Editar Usuário
      </Heading>
      {loading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <><div className="row mb-3">
          <div className="col-md-6 mb-4">
            <FormControl isRequired isInvalid={formValues.codPerfilAcesso.error}>
              <FormLabel mb="8px">Perfil de Usuário</FormLabel>
              <Select
                placeholder='Selecione o tipo de perfil'
                borderColor="gray.300"
                _hover={{ borderColor: 'blue.500' }}
                value={formValues.codPerfilAcesso.value}
                onChange={(e) => handleFieldChange('codPerfilAcesso', e.target.value)}
              >
                {codPerfilAcesso.length != null ? (
                  codPerfilAcesso.map(perfil => (
                    <option key={perfil.codPerfilAcesso} value={perfil.codPerfilAcesso}>
                      {perfil.dscPerfilAcesso}
                    </option>
                  ))
                ) : (
                  <option disabled>Sem tipos de perfis disponíveis</option>
                )}
              </Select>
            </FormControl>
          </div>
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">CPF</FormLabel>
              <Input
                placeholder='Digite um CPF'
                isReadOnly
                backgroundColor='#f5f5f5'
                cursor='not-allowed'
                variant="outline"
                borderColor="gray.300"
                _hover={{
                  borderColor: 'blue.500',
                }}
                _focus={{
                  borderColor: 'blue.500',
                  boxShadow: '0 0 0 1px blue.500',
                }}
                ref={cpfRef}
                value={mascaraCpf(formValues.dscCpf.value)}
                onChange={(e) => handleFieldChange('dscCpf', e.target.value.trim())}
                minLength={11}
                maxLength={60} />
            </FormControl>
          </div>
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">Nome</FormLabel>
              <CustomInput
                placeholder='Digite um nome'
                value={formValues.dscNome.value}
                onChange={(e) => handleFieldChange('dscNome', e.target.value)}
                maxLength={160}
                minLength={3} />
            </FormControl>
          </div>
          <div className="col-md-2 mb-4">
            <FormControl isRequired={campoObrigatorio}>
              <FormLabel mb="8px">DDD do celular</FormLabel>
              <CustomInput
                placeholder='DDD'
                value={formValues.dscDdd.value}
                onChange={(e) => handleFieldChange('dscDdd', e.target.value)}
                minLength={2}
                maxLength={2} />
            </FormControl>
          </div>
          <div className="col-md-4 mb-4">
            <FormControl isRequired={campoObrigatorio}>
              <FormLabel mb="8px">Número do Celular</FormLabel>
              <CustomInput
                placeholder='Digite um número de celular'
                value={mascaraCelular(formValues.dscCelular.value)}
                onChange={(e) => handleFieldChange('dscCelular', e.target.value.trim())}
                minLength={10}
                maxLength={10} />
            </FormControl>
          </div>
          <div className="col-md-6 mb-4">
            <FormControl isRequired isInvalid={!isEmailValido} marginBottom={'24px'}>
              <FormLabel mb="8px">E-mail</FormLabel>
              <CustomInput
                placeholder='Digite um e-mail'
                type={'email'}
                value={formValues.dscEmail.value}
                onChange={(e) => handleFieldChange('dscEmail', e.target.value)}
                maxLength={80} />
              {!isEmailValido && (
                <FormErrorMessage>Por favor, insira um e-mail válido.</FormErrorMessage>
              )}
            </FormControl>
            <FormControl className="mb-4 profile-upload">
              <label className="upload-label">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                />
                <div className="image-preview">
                  {profileImagePreview ? (
                    <img src={atualizarPreview(profileImagePreview)} alt="Profile" />
                  ) : (
                    <span>Foto de Perfil</span>
                  )}
                </div>
                <div className="camera-icon">
                  <Camera size={20} />
                </div>
              </label>
            </FormControl>
            <FormControl className='mb-4'>
              {secretarias.length > 0 && (
                <>
                  <Flex justify="space-between" align="center" mb="8px">
                    <FormLabel mb="8px">
                      Associe o usuário a uma secretaria (opcional)
                    </FormLabel>
                  </Flex>

                  <Box
                    border="1px solid"
                    borderColor="gray.300"
                    borderRadius="md"
                    p={3}
                  >
                    <Box overflow="hidden">
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <thead>
                          <tr>
                            <th style={{ textAlign:'center', padding:'8px', borderBottom:'1px solid #ddd' }}></th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Código</th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Secretaria</th>
                          </tr>
                        </thead>
                      </table>
                    </Box>

                    <Box 
                      className="sidebar-checkbox-pagina"
                      overflowX="auto"
                      overflowY={secretarias.length > 5 ? 'auto' : 'visible'}
                      maxH={secretarias.length > 5 ? '240px' : 'unset'}
                    >
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <tbody>
                          {secretarias.map((secretaria: any) => (
                            <tr key={secretaria.codSecretaria}>
                              <td style={{ textAlign:'center', padding:'8px', borderBottom:'1px solid #ddd' }}>
                                <Checkbox
                                  isChecked={(formValues.secretariaId.value ?? [])
                                    .includes(Number(secretaria.codSecretaria))}
                                  onChange={(e) => handleCheckboxSecretaria(Number(secretaria.codSecretaria), e)}
                                />
                              </td>
                              <td style={{ padding:'8px', borderBottom:'1px solid #ddd' }}>
                                {secretaria.codSecretaria}
                              </td>
                              <td style={{ padding:'8px', borderBottom:'1px solid #ddd' }}>
                                {secretaria.dscSecretaria}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Box>
                  </Box>
                </>
              )}
            </FormControl>
          </div>
          {/* <div className="col-md-6 mb-4">
            <FormControl isRequired isInvalid={formValues.dscSenha.error && formValues.dscSenha.value.length >=1}>
              <FormLabel mb="8px">Senha</FormLabel>
              <CustomInput
                type="password"
                value={formValues.dscSenha.value || ''}
                onChange={(e) => handleFieldChange('dscSenha', e.target.value)}
                minLength={8}
                maxLength={255}
                placeholder="********" />
              {(formValues.dscSenha.error && formValues.dscSenha.value.length >=1 ) && (
                <FormErrorMessage>
                  A senha deve possuir no mínimo 8 caracteres, e deve conter letras, números e pelo menos um dos seguintes sinais: #$%!@.
                </FormErrorMessage>
              )}
              
            </FormControl>
          </div> */}
          <div className="col-md-6 mb-4">
            <FormControl isRequired marginBottom={'24px'}>
              <FormLabel mb="8px">Situação</FormLabel>
              <RadioGroup
                mt={3.5}
                onChange={(value) => handleFieldChange('sitRegistro', Number(value))}
                value={formValues.sitRegistro.value.toString()}
              >
                <Radio value="1" mr={5}>Ativo</Radio>
                <Radio value="0">Inativo</Radio>
              </RadioGroup>
            </FormControl>
            <FormControl isRequired>
              <Flex justify="space-between" align="center" mb="8px">
                <FormLabel mb="8px">
                  Escolha as categorias de publicações permitidas para este usuário
                </FormLabel>
              </Flex>
              <div className="sidebar-checkbox-pagina">
                <Stack spacing={5}>
                  {categorias.length > 0 ? (
                    categorias.map((categoria) => {
                      return (
                        <Flex key={categoria.seqCategoria} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                          <Checkbox
                            className="checkCategorias"
                            isChecked={formValues.categoriaId.value.includes(categoria.seqCategoria.toString())}
                            onChange={(e) => handleCheckboxChange(categoria.seqCategoria, e)}
                          >
                            {categoria.dscCategoria}
                          </Checkbox>
                        </Flex>
                      );
                    })
                  ) : (
                    <p>Não há categorias disponíveis.</p>
                  )}
                </Stack>
              </div>
            </FormControl>
          </div>

        </div>
          <Flex justifyContent={'end'}>
            <Button type="submit" m="6px" onClick={() => navigate('/cms/configuracao/gerenciar-usuario')}>
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              onClick={() => {
                handleSubmit()
                // navigate(-1);
              }}
              isDisabled={!isFormValid()}
            >
              Editar Usuário
            </Button>
          </Flex>
        </>
      )}
    </Flex>
  )
}

export default AdicionarUsuario;
